export default {
	appName: process.env.VUE_APP_APPNAME,
	baseUrl: process.env.VUE_APP_API_URL,
	// baseUrl: 'http://192.168.0.190:9501',
	webUrl: process.env.VUE_APP_WEB_URL,
	serverHost: process.env.VUE_APP_SERVER_HOST,
	socketHost: process.env.VUE_APP_SOCKET_HOST,
	thirdAppId: process.env.VUE_APP_THIRD_APP_ID,
	apiKey: process.env.VUE_APP_APIKEY,
}